/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Blank_FramesInputs */

const en_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert blank frames`)
};

const fr_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer des images vides`)
};

const de_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Rahmen einfügen`)
};

const it_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci cornici vuote`)
};

const ru_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте пустые рамки`)
};

const es_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar marcos en blanco`)
};

const zh_cn2_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入空白框架`)
};

const ja_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白のフレームを挿入する`)
};

const hi_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डालें`)
};

const pt_pt2_insert_blank_frames = /** @type {(inputs: Insert_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira molduras em branco`)
};

/**
* | output |
* | --- |
* | "Insert blank frames" |
*
* @param {Insert_Blank_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_blank_frames = /** @type {((inputs?: Insert_Blank_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Blank_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_blank_frames(inputs)
	if (locale === "de") return de_insert_blank_frames(inputs)
	if (locale === "it") return it_insert_blank_frames(inputs)
	if (locale === "ru") return ru_insert_blank_frames(inputs)
	if (locale === "es") return es_insert_blank_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_blank_frames(inputs)
	if (locale === "ja") return ja_insert_blank_frames(inputs)
	if (locale === "hi") return hi_insert_blank_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_blank_frames(inputs)
	return en_insert_blank_frames(inputs)
});